import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData, SyncData, SyncReprint, deleteData, TableNameChanges } from '../../../apiService';
import {
    Card,
    CardContent,
    IconButton,
    Typography,
    Paper,
    TableHead
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import InfoIcon from '@mui/icons-material/Info';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import RestaurantMenu from '@mui/icons-material/Restaurant';
import ReactDOM from 'react-dom';
import EstimatePrint from '../KOT/Estimate'; // Import the LabelPrint component
import BillPrint from '../Sale/Bill'; // Import the LabelPrint component
import Payment from '@mui/icons-material/Payment';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import DoneIcon from '@mui/icons-material/Done';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import DescriptionModal from './DescriptionModal'; // Import the DescriptionModal component
import CircularProgress from '@mui/material/CircularProgress';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import Modal from '@mui/material/Modal';

const EditKOT = () => {
    const { id } = useParams();
    const history = useHistory();
    const { isAuthenticated, companyId, userId, permissions, token, logout, roleName } = useAuth();
    const [discountOptions, setDiscountOptions] = useState([]);
    const [selecteDiscount, setSelectedDiscount] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');


    const [expandedCategories, setExpandedCategories] = useState([]);
    const handleExpandClick = (categoryName) => {
        setExpandedCategories((prevExpanded) => {
            if (prevExpanded.includes(categoryName)) {
                return prevExpanded.filter((cat) => cat !== categoryName);
            } else {
                return [...prevExpanded, categoryName];
            }
        });
    };

    const [isModalDiscOpen, setIsModalDiscOpen] = useState(false);
    const [selectedItemId, setSelectedItemId] = useState(null);
    const [description, setDescription] = useState('');

    const saveDescription = (newDescription) => {
        setSelectedItems((prevItems) =>
            prevItems.map((item) =>
                item.ItemId === selectedItemId
                    ? { ...item, description: newDescription }
                    : item
            )
        );

        setIsModalDiscOpen(false);
    };

    const [totalQuantity, setTotalQuantity] = useState(0);
    const [kotDate, setKOTDate] = useState('');
    const [kotTime, setKOTTime] = useState('');
    const [tableName, setTableName] = useState('');
    const [tableId, setTableId] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const [correctPassword, setcorrectPassword] = useState('');

    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split('T')[0];
    const formattedTime = currentDate.toTimeString().split(' ')[0];

    const [categoryData, setCategoryData] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [orderedItems, setOrderedItems] = useState([]);

    useEffect(() => {
        fetchData('KOTApi', `/ItemTableDetails/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setCategoryData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Category Data:', error);
            });

        fetchData('KOTApi', `/OrderItemDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setOrderedItems(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Category Data:', error);
            });

        fetchData('KOTApi', `/TableNameDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setTableId(response.response_data.Id);
                    setTableName(response.response_data.Name);
                    setKOTDate(formattedDate);
                    setKOTTime(formattedTime);
                }
            })
            .catch((error) => {
                console.error('Error fetching Table Name Details:', error);
            });
        fetchData('CompanyApi', `/CompanyDetails/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setcorrectPassword(response.response_data.ReprintPassword);
                }
            })
            .catch((error) => {
                console.error('Error fetching Table Name Details:', error);
            });

        fetchData('KOTApi', `/GetDiscountOptions/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setDiscountOptions(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Discount Options:', error);
            });
    }, [id, formattedDate, formattedTime]);

    const handleIncrement = (CategoryId, ItemId, itemName) => {
        setSelectedItems((prevItems) => {
            const existingItem = prevItems.find((item) => item.ItemId === ItemId);
            if (existingItem) {
                // If the item is already in the list, update its quantity
                setTotalQuantity((prevTotal) => prevTotal + 1);
                return prevItems.map((item) =>
                    item.ItemId === ItemId ? { ...item, Quantity: item.Quantity + 1 } : item
                );
            } else {
                // If the item is not in the list, add it with quantity 1
                setTotalQuantity((prevTotal) => prevTotal + 1);
                return [...prevItems, { CategoryId, ItemId, Quantity: 1, itemName }];
            }
        });
    };

    const handleDecrement = (ItemId) => {
        setSelectedItems((prevItems) => {
            const existingItem = prevItems.find((item) => item.ItemId === ItemId);
            if (existingItem) {
                setTotalQuantity((prevTotal) => Math.max(prevTotal - 1, 0)); // Decrement total quantity
                // If the item is already in the list, update its quantity
                return prevItems.map((item) =>
                    item.ItemId === ItemId ? { ...item, Quantity: Math.max(item.Quantity - 1, 0) } : item
                );
            } else {
                // If the item is not in the list, do nothing
                return prevItems;
            }
        });
    };

    const getTotalQuantityForCategory = (categoryId) => {
        return selectedItems
            .filter((item) => item.CategoryId === categoryId)
            .reduce((total, item) => total + item.Quantity, 0);
    };

    const getOrderTotalQuantity = (Id) => {
        return orderedItems
            .filter((item) => item.Id === Id)
            .reduce((total, item) => total + item.TotalQty, 0);
    };

    const getTotalQuantity = () => {
        return orderedItems
            .reduce((total, item) => total + item.TotalQty, 0);
    };

    const submitData = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const kotdata = {
            Id: id,
            TableId: tableId,
            ModifiedBy: userId,
            CompanyId: companyId,
            ModifiedDate: new Date(),
        };

        const CreateData = {
            KOT: kotdata,
            KOTDetails: selectedItems
        };

        updateData('KOTApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                if (response.response === '1111' && companyId != 4) {
                    const kotid = response.kotId;
                    handleKOTPrint(kotid);
                }
                setIsLoading(false);
                history.push('/Home');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });

    };

    const handleKOTPrint = async (kotid) => {
        try {

            const response = await fetchData('KOTApi', `/KOTPrint/${kotid}`, token);
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                <EstimatePrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();
            iframe.contentWindow.print();

            // Update each record to the API after printing      
            try {
                SyncData('KOTApi', `${kotid}`, token)
            } catch (updateError) {
                console.error('Error updating record:', updateError);
            }


        } catch (error) {
            console.error('Error printing Estimate:', error);
        }
    };

    // FOR FINAL BILL

    const [modalData, setModalData] = useState({
        CompanyId: '',
        InvoiceDate: '',
        InvoiceTime: '',
        InvoiceNumber: '',
        TableId: '',
        KOTId: '',
        FinYear: '',
        Amount: '',
        DiscountAmount: '',
        DiscountPer: '',
        NetAmount: '',
        CGSTAmount: '',
        SGSTAmount: '',
        IGSTAmount: '',
        TotalAmount: '',
        RoundOff: '',
        PaymentType: '',
        CreatedBy: '',
        CreatedDate: ''
    });

    const [itemdata, setData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);



    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const openDetailModal = async (item) => {

        try {
            const response = await fetchData('SaleApi', `/InvoiceCreateDetails/${id}`, token);
            if (response.responseCode === '1111') {
                setModalData(response.response_data.Sale);
                setData(response.response_data.SaleDetails);

                setModalData((prevData) => ({
                    ...prevData,
                    InvoiceDate: formattedDate,
                    InvoiceTime: formattedTime,
                    CreatedBy: userId,
                }));

                setKOTDate(formattedDate);
                setKOTTime(formattedTime);

                setIsModalOpen(true);

            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
        }
    };

    const [selectedPaymentType, setSelectedPaymentType] = useState("1");
    // const handleChange = (event) => {
    //     setSelectedPaymentType(event.target.value);
    //     setModalData((prevData) => ({
    //         ...prevData,
    //         PaymentType: event.target.value,
    //     }));
    // };

    const handleChange = (event) => {
        const { name, value, type } = event.target;

        if (name === 'DiscountPer') {
            const discountPercentage = parseFloat(value) || 0;
            setSelectedDiscount(discountPercentage);
            setModalData((prevData) => ({
                ...prevData,
                DiscountPer: discountPercentage.toFixed(2),
                ModifiedBy: userId,
            }));


            // Calculate discount and other values for each item in itemdata
            const updatedItemData = itemdata.map((item) => {
                const amount = parseFloat(item.Amount) || 0;
                const discountAmount = (amount * discountPercentage) / 100;
                const netAmount = (amount - discountAmount).toFixed(2);
                const cgstAmount = ((netAmount * (item.GSTRate / 2)) / 100).toFixed(2);
                const sgstAmount = ((netAmount * (item.GSTRate / 2)) / 100).toFixed(2);
                const totalAmount = (parseFloat(netAmount) + parseFloat(cgstAmount) + parseFloat(sgstAmount)).toFixed(2);

                return {
                    ...item,
                    DiscountPer: discountPercentage.toFixed(2),
                    DiscountAmount: discountAmount.toFixed(2),
                    NetAmount: netAmount,
                    CGSTAmount: cgstAmount,
                    SGSTAmount: sgstAmount,
                    TotalAmount: totalAmount,
                };
            });

            setData(updatedItemData);


            // Update the totals based on the updatedItemData
            const invAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const netAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
            const cgstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const sgstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const igstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount) || 0, 0);
            const discAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);

            totalCalculation(invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount);

        }
        else {
            setSelectedPaymentType(event.target.value);
            setModalData((prevData) => ({
                ...prevData,
                PaymentType: event.target.value,
            }));

        }
    };

    const totalCalculation = (invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount) => {
        const packingCharge = parseFloat(modalData.PackingCharge) || 0;
        let amount = parseFloat(invAmount);
        let netamount = parseFloat(netAmount);
        let netAmt = netAmount + parseFloat(cgstAmount) + parseFloat(sgstAmount) + parseFloat(igstAmount) + packingCharge;
        let roundOffValue = Math.round(netAmt) - netAmt;
        let totalAmount = (netAmt + roundOffValue).toFixed(2);

        setModalData((prevData) => ({
            ...prevData,
            Amount: amount.toFixed(2),
            NetAmount: netamount.toFixed(2),
            TotalAmount: totalAmount,
            DiscountAmount: discAmount.toFixed(2),
            RoundOff: roundOffValue.toFixed(2),
            CGSTAmount: cgstAmount.toFixed(2),
            SGSTAmount: sgstAmount.toFixed(2),
            IGSTAmount: igstAmount.toFixed(2),
            ModifiedBy: userId,
        }));
    };

    const updateRecord = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        const isConfirmed = window.confirm("Are you sure you want to save the record?");

        if (isConfirmed) {

            const CreateData = {
                Sale: modalData,
                SaleDetails: itemdata
            };

            postData('SaleApi', CreateData, token)
                .then((response) => {
                    if (response.response === '1111') {
                        const SaleId = response.kotId;
                        handleSalePrint(SaleId);
                        setIsLoading(false);
                    }

                    history.push('/Home');
                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                })
                .catch((error) => {
                    console.error('KOT Create error:', error);
                });
        }
    };

    const CancelRecord = async (event) => {
        event.preventDefault();

        const isConfirmed = window.confirm("Are you sure you want to cancel the record?");

        if (isConfirmed) {

            try {
                const response = await deleteData('KOTApi', `${id}`, token);
                if (response) {
                    history.push('/Home');
                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                }
            } catch (error) {
                console.error('Error deleting record:', error);
            }
        }
    };




    const handleSalePrint = async (SaleId) => {
        try {

            const response = await fetchData('SaleApi', `/SalePrint/${SaleId}`, token);
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();
            // iframe.contentWindow.print();
            setTimeout(() => {
                iframe.contentWindow.print();
            }, 1000);

        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };

    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [isPasswordDialogOpen, setIsPasswordDialogOpen] = useState(false);

    // Function to handle password input change
    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    };

    // Function to handle password check
    const handlePasswordCheck = () => {
        // Perform your password check logic here
        // For simplicity, let's assume the correct password is 'secret'

        if (password === correctPassword) {
            // Password is correct, proceed to reprint KOT
            setIsPasswordDialogOpen(false);
            reprintKOT(id);
            setPassword('');
        } else {
            // Password is incorrect, show error message
            setPasswordError('Incorrect password. Please try again.');
        }
    };


    const reprintKOT = async (id) => {
        try {

            const response = await fetchData('KOTApi', `/KOTREPrint/${id}`, token);
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                <EstimatePrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();
            iframe.contentWindow.print();

            // Update each record to the API after printing      
            try {
                SyncReprint('KOTApi', `${id}`, `${userId}`, token)
            } catch (updateError) {
                console.error('Error updating record:', updateError);
            }


        } catch (error) {
            console.error('Error printing Estimate:', error);
        }
    };

    const [isModalEditOpen, setIsModalEditOpen] = useState(false);

    const openEditModal = () => {
        {
            setIsModalEditOpen(true);
        }
    }

    const closeEditModal = () => {
        {
            setIsModalEditOpen(false);
        }
    }

    const [selectedTable, setSelectedTable] = useState("");
    const [dropdownTableOptions, setDropdownTableOptions] = useState([]);
    useEffect(() => {
        fetchDropdownTableOptions();
    }, []);

    const fetchDropdownTableOptions = () => {
        // const response = await fetchData('KOTApi', `/KOTREPrint/${id}`, token);
        fetchData('KOTApi', `/tableName/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownTableOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Table dropdown options:', error);
            });
    };


    const handleUpdate = async () => {
        // Check if a valid table is selected
        if (!selectedTable) {
            alert("Please select a table.");
            return;
        }

        try {
            //   SyncReprint('KOTApi', `${id}`, `${userId}`, token)
            const response = await TableNameChanges('KOTApi', `${id}`, `${selectedTable}`, token);
            if (response) {
                history.push('/Home');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            }
        } catch (error) {
            console.error('Error deleting record:', error);
        }

    };



    return (
        <div className="container mx-auto mt-2 p-4 max-w-screen-md" style={{ maxHeight: '820px', overflowY: 'auto' }}>
            <style>
                {`
                /* Hide scrollbar for Chrome, Safari, and Opera */
                .container::-webkit-scrollbar {
                width: 0.2em;
                }

                .container::-webkit-scrollbar-track {
                background: rgba(255,255,255,0);
                }

                .container::-webkit-scrollbar-thumb {
                background-color: rgba(255,255,255,0);
                border-radius: 4px;
                }

                /* Responsive styling for smaller screens */
                @media (max-width: 768px) {
                .container {
                width: 100%;
                }

                .modal-dialog {
                width: 90%;
                max-width: 100%;
                }

                .modal-dialog input[name="InvoiceDate"],
                .modal-dialog input[name="InvoiceTime"] {
                width: calc(50% - 12px); /* Adjust the width as needed */
                margin-right: 12px; /* Adjust the margin between elements */
                }

                .modal-dialog .w-1/10 {
                width: 10%; /* Adjust the width of the columns */
                margin-right: 12px; /* Adjust the margin between elements */
                }

                .modal-dialog .w-1/2 {
                width: 50%; /* Adjust the width of the columns */
                }

                .modal-dialog button {
                font-size: 12px; /* Adjust the font size to make the buttons smaller */
                padding: 8px 12px; /* Adjust padding for a smaller button size */
                }
            }


                `}

            </style>
            <form onSubmit={submitData}>
                {totalQuantity > 0 && (
                    <div className="flex mb-2">
                        <div className="banner-style" style={{ display: 'flex', alignItems: 'center', padding: '10px', borderRadius: '8px', width: '100%' }}>
                            {/* <RestaurantMenu style={{ color: 'black' }} />
                            <h3 className="flex-grow text-black font-serif" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', marginLeft: '10px' }}>
                                {totalQuantity} Items
                            </h3> */}
                            <RestaurantMenu style={{ color: 'brown' }} />
                            <h6 className="flex-grow text-black font-serif" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', marginLeft: '10px' }}>
                                <span style={{ fontFamily: 'arial', fontSize: '16px', fontWeight: 'bolder' }}>{totalQuantity}</span> ITEMS
                            </h6>
                            <Button
                                style={{
                                    backgroundColor: '#294B29',
                                    borderRadius: '50px',
                                    padding: '10px 20px',
                                    color: 'whitesmoke',
                                    fontWeight: 'bolder',
                                    textTransform: 'none',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                    maxHeight: '35px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: '10px',

                                }}
                                onClick={submitData}
                                disabled={isLoading}
                            >

                                {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>Send to Kitchen</b>}

                            </Button>

                        </div>
                    </div>
                )}
                {/* className="banner-style" */}
                {totalQuantity == 0 && (
                    <div className="flex mb-2">
                        <div style={{ display: 'flex', alignItems: 'center', padding: '5px', borderRadius: '8px', width: '100%' }}>
                            <Payment style={{ color: 'darkgreen', fontSize: '25px', marginTop: '-5px' }} />
                            <h6 className="flex-grow text-black" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', marginLeft: '10px' }}>
                                <span style={{ fontFamily: 'arial', fontSize: '16px' }}>{getTotalQuantity()}</span> ITEMS ADDED
                            </h6>

                            {hasCreateTransactionPermission && roleName !== "Counter" && (
                                <Button
                                    // variant="contained"
                                    // color="primary"
                                    // style={{ marginLeft: 'auto' }}
                                    style={{
                                        backgroundColor: '#294B29',
                                        borderRadius: '50px',
                                        padding: '10px 20px',
                                        color: 'whitesmoke',
                                        fontWeight: 'bolder',
                                        textTransform: 'none',
                                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                        maxHeight: '35px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginLeft: '10px',

                                    }}
                                    onClick={openDetailModal}
                                >
                                    Bill
                                </Button>
                            )}


                            {hasEditTransactionPermission && (
                                <Fragment>
                                    <Button
                                        style={{
                                            backgroundColor: '#01204E',
                                            borderRadius: '50px',
                                            padding: '10px 20px',
                                            color: 'whitesmoke',
                                            fontWeight: 'bolder',
                                            textTransform: 'none',
                                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                            maxHeight: '35px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginLeft: '10px',

                                        }}
                                        onClick={() => setIsPasswordDialogOpen(true)}
                                    >
                                        Reprint
                                    </Button>

                                    <Dialog open={isPasswordDialogOpen} onClose={() => setIsPasswordDialogOpen(false)}>
                                        <DialogTitle>Password Check</DialogTitle>
                                        <DialogContent>
                                            <TextField
                                                label="Password"
                                                type="password"
                                                fullWidth
                                                variant="outlined"
                                                value={password}
                                                onChange={handlePasswordChange}
                                                error={Boolean(passwordError)}
                                                helperText={passwordError}
                                            />
                                        </DialogContent>
                                        <Button onClick={handlePasswordCheck} color="secondary" variant="contained">
                                            Confirm
                                        </Button>
                                    </Dialog>
                                </Fragment>
                            )}

                            {hasDeleteTransactionPermission && (
                                <Button
                                    // variant="contained"
                                    // color="warning"
                                    // style={{ marginLeft: '10px' }}
                                    style={{
                                        backgroundColor: '#FF5F00',
                                        borderRadius: '50px',
                                        padding: '10px 20px',
                                        color: 'whitesmoke',
                                        fontWeight: 'bolder',
                                        textTransform: 'none',
                                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                        maxHeight: '35px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginLeft: '10px',

                                    }}
                                    onClick={CancelRecord}
                                >
                                    Cancel
                                </Button>
                            )}

                        </div>
                    </div>
                )}

                {isModalOpen && (
                    <div className="fixed top-0 inset-x-0 flex items-center justify-center z-1">
                        <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '99%', maxWidth: '800px' }}>

                            <div className="w-full mb-4 flex">

                                <div className="w-1/2 radio-group">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Payment Type
                                    </label>
                                    <div className="flex items-center">
                                        <label className="block uppercase tracking-wide text-gray-700  font-bold mr-2">
                                            <input type="radio" name="PaymentType" value="1"
                                                checked={selectedPaymentType === "1"}
                                                onChange={handleChange} />
                                            Cash
                                        </label>
                                        <label className="block uppercase tracking-wide text-gray-700  font-bold mr-2">
                                            <input type="radio" name="PaymentType" value="2"
                                                checked={selectedPaymentType === "2"}
                                                onChange={handleChange} />
                                            Card
                                        </label>
                                        <label className='block uppercase tracking-wide text-gray-700  font-bold'>
                                            <input type="radio" name="PaymentType" value="3"
                                                checked={selectedPaymentType === "3"}
                                                onChange={handleChange} />
                                            UPI
                                        </label>
                                    </div>
                                </div>

                                <div className="w-1/2 flex justify-end">
                                    <button className="bg-green-500 text-white px-2 py-1 rounded" style={{ height: '45px' }} disabled={isLoading} onClick={updateRecord}
                                    >
                                        {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>SAVE</b>}
                                    </button>
                                    <button className="bg-blue-500 text-white px-2 py-1 rounded ml-2" style={{ height: '45px' }} onClick={toggleModal}>
                                        Cancel
                                    </button>
                                </div>
                            </div>

                            <div className="text-center mb-4">
                                <h2 className="text-2xl font-bold text-gray-800">Invoice</h2>
                            </div>
                            <div className="flex mb-2">
                                <div>
                                    <p className="text-gray-700 font-bold">Table:  {`${modalData.TableText}`} | {`${modalData.InvoiceDate} - ${modalData.InvoiceTime}`} </p>
                                </div>
                            </div>
                            <div className="w-full mb-4 flex">
                                <div className="w-1/10 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Invoice No
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        type="text"
                                        name="InvoiceNumber"
                                        placeholder="Invoice No"
                                        value={modalData.InvoiceNumber}
                                        readOnly
                                    />
                                </div>

                                <div className="w-1/10 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Disc %
                                    </label>

                                    {(companyId === "4" || companyId === "1") ? (
                                        <div>
                                            <select
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                                name="DiscountPer"
                                                value={selecteDiscount}
                                                onChange={handleChange}
                                            >
                                                <option value="">Dics %</option>
                                                {discountOptions.map((option, index) => (
                                                    <option key={option.DiscPercentage} value={option.DiscPercentage}>
                                                        {option.DiscPercentage}%
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    ) : (
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                            type="text"
                                            name="DiscountPer"
                                            placeholder="Disc %"
                                            value={modalData.DiscountPer}
                                            onChange={handleChange}
                                        />
                                    )}
                                </div>


                                <div className="w-1/10 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" >
                                        Total Amount
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                        type="text"
                                        name="TotalAmount"
                                        placeholder="Total Amount"
                                        value={modalData.TotalAmount}
                                        readOnly
                                    />
                                </div>
                            </div>


                            <div className='container w-full mb-5 flex' style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead sx={{ backgroundColor: '#f3f3f3' }}> {/* Set background color */}
                                            <TableRow>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd' }}>Item Name</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center' }}>Rate</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center' }}>Quantity</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {itemdata && itemdata.map(item => (
                                                <TableRow key={item.Id}>
                                                    <TableCell className="customTableCell" sx={{ height: '40px', width: '650px', padding: '10px' }}>{item.ItemName}</TableCell>
                                                    <TableCell className="customTableCell" sx={{ height: '40px', width: '150px', padding: '10px', textAlign: 'center' }}>{item.Rate}</TableCell>
                                                    <TableCell className="customTableCell" sx={{ height: '40px', width: '150px', padding: '10px', textAlign: 'center' }}>{item.Quantity}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>


                        </div>
                    </div>
                )}

                {isModalDiscOpen && (
                    <DescriptionModal
                        isOpen={isModalDiscOpen}
                        onClose={() => setIsModalDiscOpen(false)}
                        itemId={selectedItemId}
                        description={description}
                        onSave={saveDescription}
                    />
                )}



                {isModalEditOpen && (
                    <Modal open={isModalEditOpen} className={isModalEditOpen ? 'notification-modal' : ''}>
                        <div className="fixed inset-0 flex items-start justify-center z-10 ">
                            <div className="bg-green-100 p-6 rounded-lg shadow-lg" style={{ width: '70%', maxHeight: '50vh', overflowY: 'auto', overflowX: 'auto', marginTop: '50px' }}>

                                <h5 style={{ textAlign: 'center' }}>Table Change</h5>
                                <div className="w-full">
                                    <label
                                        style={{
                                            display: "block",
                                            textTransform: "uppercase",
                                            letterSpacing: "0.05em",
                                            color: "black",
                                            fontSize: "12px",
                                            fontWeight: "bold",
                                            marginBottom: "8px",
                                        }}
                                        htmlFor="gstNumber"
                                    >
                                        Name
                                        <span style={{ color: "red" }}>*</span>
                                    </label>

                                    <select
                                        style={{
                                            width: "100%",
                                            height: "35px",
                                            padding: "5px",
                                            borderRadius: "4px",
                                            border: "1px solid #ccc",
                                            fontSize: "14px",
                                        }}
                                        value={selectedTable}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSelectedTable(selectedValue);

                                            // Find the selected table's record in dropdownTableOptions
                                            const selectedTableRecord = dropdownTableOptions.find(
                                                (category) => category.Id === selectedValue
                                            );

                                            // Update formData with TableId and GstNotApplicable
                                            setModalData((prevData) => ({
                                                ...prevData,
                                                TableId: selectedValue,

                                            }));
                                            setTableId(selectedValue)
                                        }}
                                    >
                                        <option value="">Table</option>
                                        {dropdownTableOptions.map((category) => (
                                            <option key={category.Id} value={category.Id}>
                                                {category.Name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <br></br>
                                <div className="w-1/2 flex justify-end">
                                    <Button className="bg-green-500 text-white px-2 py-1 rounded"
                                        style={{
                                            backgroundColor: '#AEEA94',
                                            borderRadius: '50px',
                                            padding: '10px 20px',
                                            color: 'whitesmoke',
                                            fontWeight: 'bolder',
                                            textTransform: 'none',
                                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                            maxHeight: '35px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginLeft: '10px',

                                        }} disabled={isLoading} onClick={handleUpdate}
                                    >
                                        {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>Update</b>}
                                    </Button>
                                    <Button className="bg-blue-500 text-white px-2 py-1 rounded ml-2"
                                        style={{
                                            backgroundColor: '#D2665A',
                                            borderRadius: '50px',
                                            padding: '10px 20px',
                                            color: 'whitesmoke',
                                            fontWeight: 'bolder',
                                            textTransform: 'none',
                                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                            maxHeight: '35px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginLeft: '10px',

                                        }}
                                        onClick={closeEditModal}>
                                        Cancel
                                    </Button>
                                </div>
                            </div>
                        </div>

                    </Modal >
                )
                }


                <div className="flex mb-2">
                    <h5 className="flex-grow text-black font-serif" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>
                        <ModeEditOutlineIcon onClick={openEditModal} style={{ color: 'orangered' }} />  KOT - {tableName}
                    </h5>
                    <div>
                        <p className="text-black font-bold">{`${kotDate} - ${kotTime}`}</p>
                    </div>
                </div>
                {categoryData.map((category) => (
                    <Card key={category.CategoryName}
                        sx={{
                            marginBottom: 1, boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            backgroundColor: 'rgba(255,255,255,0.8)'
                            //backgroundColor: '#BFF6C3'

                        }}>
                        <CardContent>
                            <Typography
                                variant="h6"
                                component="div"
                                sx={{
                                    marginBottom: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    height: '10px',
                                    fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                                    fontSize: '20px',
                                    cursor: 'pointer', // Add cursor style for indicating it's clickable
                                }}
                                onClick={() => handleExpandClick(category.CategoryName)}
                            >
                                {category.CategoryName}
                                {getTotalQuantityForCategory(category.CategoryId) > 0 && (
                                    <span style={{ marginLeft: 'auto', marginRight: '10px' }}>
                                        ({getTotalQuantityForCategory(category.CategoryId)} items)
                                    </span>
                                )}
                                <IconButton
                                    aria-expanded={expandedCategories.includes(category.CategoryName)}
                                    aria-label="show more"
                                    sx={{ marginLeft: 'auto' }}
                                >
                                    <ExpandMoreIcon />
                                </IconButton>
                            </Typography>
                            <Collapse in={expandedCategories.includes(category.CategoryName)} timeout="auto" unmountOnExit>
                                <TableContainer>
                                    <Table>
                                        <TableBody>
                                            {category.Items.map((item) => (
                                                <TableRow key={item.Id} sx={{ backgroundColor: getOrderTotalQuantity(item.Id) > 0 ? 'lightgreen' : 'inherit' }}>


                                                    <TableCell sx={{ fontSize: '16px', width: '200px' }}>
                                                        {getOrderTotalQuantity(item.Id) > 0 ? (
                                                            <span style={{ color: 'green' }}>
                                                                ({getOrderTotalQuantity(item.Id)}){' '}
                                                            </span>
                                                        ) : null}
                                                        {item.Name}
                                                    </TableCell>

                                                    <TableCell sx={{ width: '150px', padding: '1px', fontSize: '16px', fontWeight: 'bold' }}>
                                                        <IconButton
                                                            color="secondary"
                                                            onClick={() => handleDecrement(item.Id)}
                                                        >
                                                            <RemoveIcon />
                                                        </IconButton>
                                                        {selectedItems.find((selectedItem) => selectedItem.ItemId === item.Id)?.Quantity || 0}
                                                        <IconButton
                                                            color="primary"
                                                            onClick={() => handleIncrement(item.CategoryId, item.Id, item.Name)}
                                                        >
                                                            <AddIcon />
                                                        </IconButton>
                                                    </TableCell>

                                                    <TableCell sx={{ width: '20px', padding: '1px', fontSize: '16px', fontWeight: 'bold' }}>
                                                        {selectedItems.find((selectedItem) => selectedItem.ItemId === item.Id)?.Quantity > 0 && (
                                                            <IconButton
                                                                color="secondary"
                                                                onClick={() => {
                                                                    setSelectedItemId(item.Id);
                                                                    setDescription(selectedItems.find((selectedItem) => selectedItem.ItemId === item.Id)?.description || '');
                                                                    setIsModalDiscOpen(true);
                                                                }}
                                                            >
                                                                <InfoIcon />
                                                            </IconButton>
                                                        )}
                                                    </TableCell>

                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Collapse>
                        </CardContent>
                    </Card>
                ))}
                <div className="flex mb-2">
                    <div>
                        <p className="text-white font-bold" hidden>{kotTime}</p>
                    </div>
                </div>
                <div className="flex mb-2">
                    <div>
                        <p className="text-white font-bold" hidden>{kotDate}</p>
                    </div>
                </div>
            </form>
        </div >
    );
};

export default EditKOT;
